import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const DeliverablesSearch = React.lazy(
  () => import('components/Deliverable/Search/Search'),
);

function ScreensDeliverablesList() {
  return (
    <BaseLayout>
      <DocumentTitle>Deliverables</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <DeliverablesSearch />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensDeliverablesList;
